import{useState as e,useEffect as r}from"react";function n(n){const[t,s]=e(!1);return r((()=>{const e=new IntersectionObserver((([e])=>s(e.isIntersecting)));return n.current&&e.observe(n.current),()=>{e.disconnect()}}),[n]),t}export{n as useIsVisible};
//# sourceMappingURL=use-is-visible.js.map
